import useFormulaClone from 'hooks/formulas/useFormulaClone';

import { FormulaCloneOptions } from 'models/formula.model';

export function useFormulaCloneManager(
    cloningFormulaId: number | null,
    clearCloningFormulaId: () => void,
) {
    const { mutate, isPending, reset } = useFormulaClone();

    const submitClone = (data: { options: FormulaCloneOptions[] }) => {
        if (!cloningFormulaId) {
            console.warn('submitClone called without a valid cloningFormulaId');
            return;
        }

        mutate(
            {
                formulaId: cloningFormulaId,
                data: { clone_options: data.options },
            },
            {
                onError: () => {
                    reset();
                },
                onSettled: () => {
                    clearCloningFormulaId();
                },
            },
        );
    };

    return {
        submitClone,
        isClonePending: isPending,
    };
}
